//----- 枚举 Start -----//
export enum TextEnum { // 文案
  Undeveloped = '暂未开发，敬请期待',
  SelectDefault = '--请选择--',
  SaveImagePC = '右键图片保存',
  ShareImagePC = '右键图片，保存分享',
  SaveImageMobile = '长按图片保存',
  ShareImageMobile = '长按图片，保存分享',
  
  // 成功
  SuccessLogin = '登录成功',
  SuccessLogout = '退出成功',
  SuccessRegister = '注册成功',
  SuccessGet = '获取成功',
  SuccessRevise = '修改成功',
  SuccessShare = '分享成功',
  
  // 错误
  ErrorCheckFail = '验证失败，请检测输入信息',
  ErrorFrequently = '请勿频繁操作',
  ErrorNetwork = '网络波动，请稍后再试',
  
  // 操作
  OperateLogin = '登录',
  OperateRegister = '注册',
  OperateReplenish = '补充信息'
}

export enum CookieEnum { // Cookie
  Token = 'GFToken', // 会话
  UserID = 'GFUserID', // 用户ID
  UserName = 'GFUserName', // 用户名
  Source = 'GFSource', // 源地址
  SourceAccess = 'GFSourceAccess', // 访问源地址
  Invite = 'GFInvite', // 邀请
  BdVid = 'GFBdVid' // 百度推广
}

export enum ParamEnum { // 参数
  Token = 'gf_token', // 会话
  UserID = 'gf_userid', // 用户ID
  UserName = 'gf_username', // 用户名
  Source = 'gf_source', // 源地址
  SourceAccess = 'utm_source', // 访问源地址
  Operate = 'gf_operate', // 反馈
  Invite = 'gf_invite', // 邀请
  BdVid = 'bd_vid' // 百度推广
}

export enum RouterEnum { // 路由
  All = '/:pathMatch(.*)*',
  Root = '/',
  Index = '/index',
  
  // SSO
  SSO = '/sso',
  SSOIndex = '/sso/index',
  Register = '/sso/register',
  Login = '/sso/login',
  Logout = '/sso/logout',
  Replenish = '/sso/replenish',
  Back = '/sso/back',
  Cancel = '/sso/cancel',
  StopCancel = '/sso/stop_cancel',
  ChannelWeChat = '/sso/channelWeChat'
}

export enum SSOEnum { // SSO
  Index = 'index', // 首页
  Register = 'register', // 注册
  Login = 'login', // 登录
  Logout = 'logout', // 退登
  Replenish = 'replenish', // 完善
  Back = 'back' // 返回
}

export enum CodeEnum { // 状态码
  Normal = 200, // 正常
  ErrorParam = 1206, // 参数错误
  ErrorAuthReset = 1209, // 授权重置
  ErrorAuthFail = 1201, // 授权失败
  ErrorAuthExpired = 1202, // 授权过期
  ErrorNotExist = 1205, // 用户不存在
  UserCanceling = 1217 // 用户注销中
}

export enum GridEnum { // 栅格
  PC = 1920,
  Mobile = 750,
  XS = 576,
  SM = 576,
  MD = 768,
  LG = 992,
  XL = 1200,
  XXL = 1600,
  XXXL = 2000
}

export enum ColorEnum { // 颜色
  Black = '#000000',
  white = '#ffffff',
  Pink = '#c41d7f',
  Red = '#cf1322',
  Orange = '#d46b08',
  Yellow = '#d4b106',
  Gold = '#d48806',
  Cyan = '#08979c',
  Lime = '#7cb305',
  Green = '#389e0d',
  Blue = '#096dd9',
  GeekBlue = '#1d39c4',
  Purple = '#531dab',
  Success = '#52c41a',
  Processing = '#1890ff',
  Error = '#f5222d',
  Warning = '#fa8c16'
}

export enum ThemeEnum { // 主题
  Light = 'light',
  Dark = 'dark'
}

export enum OperateEnum { // 操作
  Register = 'register',
  Login = 'login',
  Logout = 'logout',
  Cancel = 'cancel',
  StopCancel = 'stop_cancel',
  WeChatLogin = 'wechat_login',
}

export enum PrometheusActionEnum { // 普罗米修斯动作
  Load = 'web_load', // 访问
  View = 'web_visit', // 切换页面
  
  // SSO
  Code = 'send_captcha', // 获取验证码
  Register = 'register', // 注册
  Login = 'login', // 登录
  
  // Store
  AppDetail = 'app_detail', // 应用详情
  AppInstall = 'app_install', // 应用安装
  AppUninstall = 'app_uninstall', // 应用卸载
  AppResume = 'app_start', // 应用重启
  AppPause = 'app_stop', // 应用暂停
  ViewRecharge = 'checkout', // 查看用户
  Recharge = 'recharge', // 充值
  BuyPlan = 'buy_monthly_plan', // 购买套餐
  SetPauseTime = 'auto_stop_time_config', // 配置暂停时间
  TeamInvite = 'invite_member', // 团队邀请成员
  TeamDelete = 'delete_member', // 团队删除成员
  TeamQuit = 'exit_group' // 团队退出
}

export enum AppletsRouterEnum { // 小程序路由
  Login = '/pages/login/index' // 登录
}

export enum AppletsParamEnum { // 小程序参数
  To = 'gf_to', // 前往
  Store = 'gf_store', // 商城
  App = 'gf_app', // 应用
  Token = 'gf_token', // 会话
  Pay = 'gf_pay' // 支付
}

//----- 枚举 End -----//

//----- 字典 Start -----//
//----- 字典 End -----//

//----- 接口 Start -----//
export interface DataInterface { // Vue数据
  enumType?: Record<string, any>; // 枚举类型
  dictType?: Record<string, any>; // 字典类型
  interfaceType?: Record<string, any>; // 接口类型
  href?: Record<string, any>; // 链接
  file?: Record<string, any>; // 文件
  setTime?: Record<string, number>; // 定时器
  request?: { // 请求
    intercept?: Record<string, any>; // 拦截
    data?: Record<string, any>; // 数据
  };
  form?: { // 提交数据
    rule?: Record<string, any>; // 规则
    data?: Record<string, any>; // 数据
  };
  table?: { // 表格
    column?: Record<string, any>; // 列
    pagination?: Record<string, any>; // 分页
  };
  drawer?: Record<string, any>; // 抽屉
  modal?: Record<string, any>; // 模态
  instance?: Record<string, any>; // 实例
  expand?: Record<string, any>; // 拓展
}

export interface BaseRequestInterface { // 基础请求
}

export interface BaseResponseInterface { // 基础结果
  code: CodeEnum; // 状态码
  message?: string; // 系统信息
  msg?: string; // 业务信息
  data: any; // 数据
}

//----- 接口 End -----//
